import { render, staticRenderFns } from "./currency-amount.vue?vue&type=template&id=6a0b83f2&scoped=true"
import script from "./currency-amount.vue?vue&type=script&lang=ts"
export * from "./currency-amount.vue?vue&type=script&lang=ts"
import style0 from "./currency-amount.vue?vue&type=style&index=0&id=6a0b83f2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0b83f2",
  null
  
)

export default component.exports